import { Link } from "wouter";
import { Layout } from "@/components/layout";
import { Button } from "@/components/ui/button";
import { Compass } from "lucide-react";

export default function NotFound() {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-24 max-w-xl text-center">
        <div className="w-16 h-16 bg-primary/10 text-primary rounded-2xl flex items-center justify-center mx-auto mb-6">
          <Compass className="w-8 h-8" aria-hidden="true" />
        </div>
        <h1 className="text-4xl font-extrabold mb-4">Page not found</h1>
        <p className="text-lg text-muted-foreground mb-8">
          We couldn&rsquo;t find what you were looking for. Try heading back to
          the catalog or the homepage.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild>
            <Link href="/courses">Browse courses</Link>
          </Button>
          <Button asChild variant="outline">
            <Link href="/">Back home</Link>
          </Button>
        </div>
      </div>
    </Layout>
  );
}
